import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';
import Button from '../../../button';
import IconBackGround from '../../../iconBackGround';
import { menuSectionStore } from '../../../../../store/menuSectionStore';
import { getGameImages } from '../../../../../core/helpers/getGameImages';
import { isMobile } from '../../../../../core/helpers/isMobile';
import { applicationStore } from '../../../../../store/applicationStore';

const PayTableButtons = observer(({ x, payTableStepCount }) => {
  const { currentPayTableStepCount, setIsShowMenuPopup, setCurrentPayTableStepCount } =
    menuSectionStore;
  const { arrowLeft, arrowRight } = useMemo(() => {
    return getGameImages();
  }, []);

  const handleArrowClick = useCallback(
    (e, isLeft = false) => {
      e.stopPropagation();
      const newCount = isLeft
        ? Math.max(0, currentPayTableStepCount - 1)
        : Math.min(payTableStepCount - 1, currentPayTableStepCount + 1);

      setCurrentPayTableStepCount(newCount);
    },
    [payTableStepCount, currentPayTableStepCount, setCurrentPayTableStepCount]
  );

  const handleClickPlayButton = useCallback(() => {
    setIsShowMenuPopup(false);
  }, [setIsShowMenuPopup]);

  return (
    <Container name='PayTableButtonsContainer'>
      {!isMobile() && (
        <IconBackGround handleSelect={(e) => handleArrowClick(e, true)}>
          <Sprite anchor={0.5} texture={arrowLeft} />
        </IconBackGround>
      )}
      <Button
        x={x}
        name='PayTablePlayButton'
        buttonText={applicationStore.canvasTranslationKeys.PLAY}
        textStyles={{
          _fontSize: 20,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _fontFamily: 'poppinsMedium',
        }}
        handleClickButton={handleClickPlayButton}
      />
      {!isMobile() && (
        <IconBackGround x={2 * x} handleSelect={handleArrowClick}>
          <Sprite anchor={0.5} texture={arrowRight} />
        </IconBackGround>
      )}
    </Container>
  );
});

export default PayTableButtons;
